export default __webpack_public_path__ + "static/media/E-WEB-Goal-11.884c794e.png";